<div class="events-list" [ngClass]="getClasses()" *ngIf="events">
  <ng-container *ngFor="let event of events">
    <article [ngClass]="getEventStyle(event)">
      <div class="event-image">
        <div class="image-holder" [title]="getEventCopyrights(event)">
          <div class="image-holder-content">
            <app-webp-image
              *ngIf="event.image"
              [src]="getEventImageUrl(event)"
              [blurhash]="event.imageBlurHash"
              [alt]="event.name"
              [blurWidth]="32"
              [blurHeight]="32"
            ></app-webp-image>
          </div>
        </div>
        <div class="event-meta">
          <div class="event-date">{{ event.startTime | date:'EEEE, dd. MMMM | HH.mm' }} Uhr</div>
        </div>
      </div>
      <div class="event-content">
        <h3>
          <a [routerLink]="['/', 'event', event.slug]">
            {{ getEventDisplayName(event) }}
          </a>
        </h3>
        <p>
          <strong [innerHtml]="event.subtitle"></strong>
        </p>
        <div class="event-date">{{ event.startTime | date:'EEEE, dd. MMMM | HH.mm' }} Uhr</div>
        <p class="event-artists" [innerHtml]="getEventArtists(event)"></p>
        <p>{{ event.location }}</p>
      </div>
      <div class="event-buttons">
        <div *ngIf="event.slug">
          <a [routerLink]="['/', 'event', event.slug]" class="button button-white">Details</a>
        </div>
        <div *ngIf="event.ticketUrl || event.externalId">
          <a *ngIf="event.externalId" class="MyEventButton no-external-link-icon button button-default" [attr.eid]="event.externalId" [attr.edid]="event.startTime" [attr.siteid]="'1AC0E12D-B0DA-4047-8A09-EEC91977AC62'">Karten kaufen</a>
          <a *ngIf="!event.externalId" target="_blank" [href]="event.ticketUrl" class="no-external-link-icon button button-default">Karten kaufen</a>
        </div>
      </div>
    </article>
  </ng-container>
</div>
